import { Component } from '@angular/core';
import { CMSService } from '../Services/cms.service';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { CmsContactUsProperties } from '../Models/CmsContactUsProperties';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-cms-sub-contactus',
  templateUrl: './cms-sub-contactus.component.html',
  styleUrls: ['./cms-sub-contactus.component.css']
})
export class CmsSubContactUsComponent {
  contactUsObj = new CmsContactUsProperties();
  constructor(private router: Router,private userService: CMSService, public cmsService: CMSService, private http: HttpClient) { }
  baseUrl = environment.baseUrl;
  public progress: number;
  public message: string;
  public imagePath: any;
  public responseMessage: string;
  public uploadFile = (files) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.http.post(this.baseUrl + '/CmsContactUs/SaveContactUsImages', formData, { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          this.imagePath = event.body;
          this.message = 'Uploaded Successfully...';
          //this.onUploadFinished.emit(event.body);
        }
      });
  }
  ngOnInit() {
    this.LoadEditableData();
  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("contactUsID") != undefined || localStorage.getItem("contactUsID") != null) {
        let id = Number(localStorage.getItem("contactUsID"));
        if (id != 0 || id != undefined) {
          this.userService.getContactUsById(id).subscribe((data) => {
            this.contactUsObj = data[0] as CmsContactUsProperties;
            localStorage.removeItem("contactUsID");
          });
        }
      }
    }
    catch (e) {
      ////console.log (e);
    }
  }
  onSubmit() {
    this.imagePath = " ";
    if (this.contactUsObj.contactUsID == 0 || this.contactUsObj.contactUsID == null) {
      this.contactUsObj.images = this.imagePath;
      this.userService.createContactUs(this.contactUsObj).subscribe((data => {
        if (data === true) {
          this.router.navigate(["/cms"]);
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data inserted Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    } else {
      this.contactUsObj.images = this.imagePath;
      this.userService.updateContactUs(this.contactUsObj).subscribe((data => {
        if (data === true) {
          this.router.navigate(["/cms"]);
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data updated Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while updating data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }

    ////////console.log (this.imagePath);
  }
  cancel() {
    this.router.navigate(["/cms"]);
  }
}
